import NoVillaFound from './NoVillaFound';

export default NoVillaFound;
